import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { TranslationsContextProvider } from './contexts/translation.context';
import { SidebarCountsProvider } from './contexts/SidebarCountsContext';
import { BreadcrumbProvider } from './contexts/BreadcrumbContext';
import RootRouter from './router';
import ru from './locales/ru.json';
import en from './locales/en.json';
import './App.css';

const getInitialLanguage = () => {
  if (typeof window === 'undefined') {
    return 'ru';
  }
  return localStorage.getItem('lang') || 'ru';
};

const App: React.FC = () => {
  const [lang, setLang] = React.useState<string>(() => getInitialLanguage());

  const dictionary = React.useMemo(() => (lang === 'en' ? en : ru), [lang]);

  const changeLanguage = React.useCallback((nextLang: string) => {
    setLang(nextLang);
    if (typeof window !== 'undefined') {
      localStorage.setItem('lang', nextLang);
    }
  }, []);

  return (
    <BrowserRouter>
      <TranslationsContextProvider
        dictionary={dictionary}
        lang={lang}
        locales={['ru', 'en']}
        changeLanguage={changeLanguage}
      >
        <AuthProvider>
          <BreadcrumbProvider>
            <SidebarCountsProvider>
              <RootRouter />
            </SidebarCountsProvider>
          </BreadcrumbProvider>
        </AuthProvider>
      </TranslationsContextProvider>
    </BrowserRouter>
  );
};

export default App;
